@if (!noContainerWhenEmpty || chips?.length > 0) {
    <span class="u-srOnly" [id]="id + '_label'">{{'Common.filter.list' | localize}}</span>
    <agpr-chip-container
        #chipContainer
        [id]="id"
        [chips]="chips"
        [chipGroups]="chipGroups"
        [overflowMessage]="overflowMessage"
        [emptyMessage]="emptyMessage"
        (removeChip)="removeChip($event)"
        [style]="style"
        [readonly]="readonly"
        [noContainerWhenEmpty]="noContainerWhenEmpty"
        ariaLabelledBy="id + '_label'"
    ></agpr-chip-container>
}
